export default {
	GET_FAQS_CONTENT: state => state.faqGroups,
}